import { httpService } from "./AxiosInstance";

export const UserToken = () => localStorage.getItem("token");

export const getUserMe = () => httpService.get(`/user/me`);

export const logIn = (data: Record<string, any>) =>
  httpService.post(`/auth/login`, data);
